import { RouterModule, Routes } from '@angular/router';
import { UploadEventQrComponent } from '../upload-event-qr/upload-event-qr.component';
import { AddHashtagsComponent } from '../add-hashtags/add-hashtags.component';
import { NgModule } from '@angular/core';
import { PhotowallConfigurationComponent } from './photowall-configuration.component';
import { SponsorDetailsComponent } from '../sponsor-details/sponsor-details.component';
import { WebQrComponent } from '../web-qr/web-qr.component';


const routes: Routes = [
  { path: '', component: PhotowallConfigurationComponent, children: [
    { path: 'upload-qrcode', component: UploadEventQrComponent },
    { path: 'add-hashtags', component: AddHashtagsComponent },
    { path: 'sponsor-detail', component: SponsorDetailsComponent },
    { path: 'web-qr', component: WebQrComponent },
    //{ path: 'add-branding', component: AddBrandingComponent },
    //{ path: 'select-photowall', component: SelectPhotowallComponent },
    { path: '', redirectTo: 'upload-qrcode', pathMatch: 'full' } // Default route
  ]}
];

NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export const PhotowallRoutes = RouterModule.forChild(routes);
